import {NumberOfPeople} from "../commonTypes";
import {getProductVariant} from "../../accountV2/common";
import {FlattenedProduct} from "./useWeekRecipes";
import {Scalars} from "@shopify/hydrogen-react/storefront-api-types";

export const recipeCatalog = (
  numberOfPeople: NumberOfPeople,
  numberOfMeals: number,
  recipes: FlattenedProduct[]
) => {
  return {
    variantIdBy(productId: string) {
      const recipe = recipes.find((it) => it.id === productId);

      if (recipe === undefined) {
        return undefined;
      }

      return getProductVariant(numberOfPeople, numberOfMeals, recipe).id;
    },
  };
};
